import React, { useEffect, useState } from "react";
import "./PaymentHistory.scss";
import { useNavigate, useParams } from "react-router-dom";
import { adminRequest } from "../../../utils/requestMethods";
import { MdArrowBack } from "react-icons/md";

const PaymentHistory = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const [payments, setPayments] = useState([]);

  const [invoice, setInvoice] = useState(null);

  const [loading, setLoading] = useState(true);

  const fetchPaymentHistory = async () => {
    try {
      const [paymentResponse, invoiceResponse] = await Promise.all([
        adminRequest.get(`/invoice/payment/history/${id}`),

        adminRequest.get(`/invoice/view/${id}`),
      ]);

      setPayments(paymentResponse.data.data);

      setInvoice(invoiceResponse.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentHistory();
  }, []);

  return (
    <div className="paymentHistoryContainer">
      <div className="pageHeader">
        <div className="leftSection">
          <button className="backBtn" onClick={() => navigate(-1)}>
            <MdArrowBack />
          </button>

          <div>
            <h2>Payment History</h2>

            {invoice && (
              <p>
                {invoice.invoice_number} • {invoice.Student?.fullName}
              </p>
            )}
          </div>
        </div>
      </div>

      {invoice && (
        <div className="invoiceSummary">
          <div className="summaryCard">
            <span>Total</span>

            <p>Rs. {invoice.total_amount}</p>
          </div>

          <div className="summaryCard paid">
            <span>Paid</span>

            <p>Rs. {invoice.paid_amount}</p>
          </div>

          <div className="summaryCard due">
            <span>Due</span>

            <p>Rs. {invoice.due_amount}</p>
          </div>

          <div className="summaryCard status">
            <span>Status</span>

            <p className={`status ${invoice.status.toLowerCase()}`}>
              {invoice.status}
            </p>
          </div>
        </div>
      )}

      <div className="historyCard">
        <div className="cardHeader">
          <h3>Payment Records</h3>
        </div>

        <div className="tableWrapper">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Amount</th>
                <th>Method</th>
                <th>Transaction ID</th>
                <th>Remarks</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="emptyState">
                    Loading payment history...
                  </td>
                </tr>
              ) : payments.length === 0 ? (
                <tr>
                  <td colSpan="6" className="emptyState">
                    No payment history found
                  </td>
                </tr>
              ) : (
                payments.map((payment, index) => (
                  <tr key={payment.id}>
                    <td>{index + 1}</td>

                    <td className="amount">Rs. {payment.amount}</td>

                    <td>
                      <span
                        className={`method ${payment.payment_method.toLowerCase()}`}
                      >
                        {payment.payment_method}
                      </span>
                    </td>

                    <td>{payment.transaction_id || "-"}</td>

                    <td>{payment.remarks || "-"}</td>

                    <td>{payment.payment_date}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PaymentHistory;
